"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _Textfield = _interopRequireDefault(require("../Textfield"));

var _class, _class2, _temp;

var Textarea = (0, _autobindDecorator["default"])(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Textarea, _Component);

  function Textarea() {
    (0, _classCallCheck2["default"])(this, Textarea);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Textarea).apply(this, arguments));
  }

  (0, _createClass2["default"])(Textarea, [{
    key: "handleHeightChange",
    value: function handleHeightChange(value, e) {
      var _this$props = this.props,
          quiet = _this$props.quiet,
          onChange = _this$props.onChange;

      if (typeof onChange === 'function') {
        onChange(value, e);
      }

      if (quiet) {
        e.target.style.height = 'auto';
        e.target.style.height = "".concat(e.target.scrollHeight, "px");
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          quiet = _this$props2.quiet,
          otherProps = (0, _objectWithoutProperties2["default"])(_this$props2, ["quiet"]);
      return _react["default"].createElement(_Textfield["default"], (0, _extends2["default"])({}, otherProps, {
        multiLine: true,
        quiet: quiet,
        onChange: this.handleHeightChange
      }));
    }
  }]);
  return Textarea;
}(_react.Component), (0, _defineProperty2["default"])(_class2, "propTypes", {
  /** Custom CSS class to add to the textarea */
  className: _propTypes["default"].string,

  /** Whether to disable the textarea */
  disabled: _propTypes["default"].bool,

  /** Whether to show the warning icon and red border */
  invalid: _propTypes["default"].bool,

  /** Function called when focus is taken away from the textarea */
  onBlur: _propTypes["default"].func,

  /** Function called when the textarea value is changed */
  onChange: _propTypes["default"].func,

  /** Function called when focus is put on the textarea */
  onFocus: _propTypes["default"].func,

  /** String to show in the textarea when nothing has been input */
  placeholder: _propTypes["default"].string,

  /** Whether the textarea should render using a quiet variant */
  quiet: _propTypes["default"].bool,

  /** Whether the textarea can only be read */
  readOnly: _propTypes["default"].bool,

  /** Whether the textarea requires user input (shows warning if empty) */
  required: _propTypes["default"].bool
}), (0, _defineProperty2["default"])(_class2, "defaultProps", {
  disabled: false,
  invalid: false,
  quiet: false,
  readOnly: false,
  required: false
}), _temp)) || _class;

exports["default"] = Textarea;